import { useState, useEffect, forwardRef, useRef } from "react";
import format from "date-fns/format";
import parseJSON from "date-fns/parseJSON";
import { getObjectValue } from "../utils/commonUtilityFunctions";
import DraftRenderer from "./DraftRenderer";
import certificate_background from "../../assets/images/certificate_background.png";
import { JSONParse } from "@cti-workspace/helpers";
import { Button } from "@cti-workspace/ui";
// import QRCode from "qrcode.react";

const DesignContainer = forwardRef(({ document, config, isFullScreen = false, onClose = () => { }, onZoom = () => { }, setShowSimple, enqueueSnackbar }, ref) => {
	const [credData, setCredData] = useState(null);
	const [style, setStyle] = useState(
		JSON.stringify({
			width: "90%",
			paddingTop: "100%",
			borderColor: "red",
			borderWidth: "1",
			position: "relative",
			backgroundImage: `url(${certificate_background})`,
			backgroundSize: "100%",
			backgroundPosition: "top",
			backgroundRepeat: "no-repeat",
			margin: "auto",
			marginTop: isFullScreen ? "0" : "2vw",
		})
	);
	const [printOrientation, setPrintOrientation] = useState("landscape");
	const scaleFullScreen = useRef(false);
	const snackbarInitiated = useRef(false);
	const decodeHTML = (html) => {
		if (!isHTML(html)) {
			let txt = window.document.createElement("textarea");
			txt.innerHTML = html;
			return txt.value.replace(/['"]+/g, "");
		} else {
			return html?.replaceAll('"', '\\"');
		}
	};

	const isHTML = (text) => {
		try {
			const fragment = new DOMParser().parseFromString(text, "text/html");
			return fragment.body.children.length > 0;
		} catch (error) {
			console.error(error);
		}
		return false;
	};

	Date.prototype.addYears = function (years) {
		var date = new Date(this.valueOf());
		console.error(date);
		console.error(years);

		date.setFullYear(date.getFullYear() + parseInt(years));
		return date;
	};

	// document?.recipient?.name?.replace(/(?:\\[rn]|[\r\n]+)+/g, "").replaceAll('"', '\\"')
	// first part remove excess empty space , second space fixes the double quote error.

	useEffect(() => {
		try {
			if (config.data) {
				try {
					let parsed = JSONParse(config.data);
					let parsedConfig = parsed.value;
					// get recipient name
					// get issued date
					// string replace
					const options = { weekday: "long", year: "numeric", month: "long", day: "numeric", timeZoneName: "short" };

					let val = parsedConfig.content;
					let rec = val.replaceAll("@Recipient_Name", document?.recipient?.name?.replace(/(?:\\[rn]|[\r\n]+)+/g, "").replaceAll('"', '\\"'));
					let issuedDate = rec.replaceAll("@Issued_Date", new Date(document?.issuedOn).toLocaleTimeString(undefined, options));
					let credName = issuedDate.replaceAll("@Credential_Name", (document?.name || "").replaceAll('"', '\\"'));
					let transcript0 = credName.replaceAll("@transcript_0", document?.transcript[0]?.grade);
					let transcript1 = transcript0.replaceAll("@transcript_1", document?.transcript[1]?.grade);
					let transcript2 = transcript1.replaceAll("@transcript_2", document?.transcript[2]?.grade);
					let credDescription = transcript2.replaceAll("@Credential_Description", decodeHTML(document?.additionalData?.description) || "");
					let imageUrl = credDescription.replaceAll("@Image_URL", document?.additionalData?.imageUrl);
					let partnerImageUrl = imageUrl.replaceAll("@Partner_Image_Url", document?.additionalData?.partnerImageUrl || "https://s3.ca-central-1.amazonaws.com/trybe.public.assets/Trybe.ID/FF4D00-0.01.png");
					let dateVal = new Date(document?.issuedOn);
					let addYears = partnerImageUrl.replaceAll("@Computed_Date", dateVal.addYears(document?.transcript[2]?.grade).toLocaleTimeString(undefined, options));
					let issuedDate_Date = addYears.replaceAll("@IssuedDate_Date", format(new Date(document?.issuedOn), "PPP"));
					let transcript3 = issuedDate_Date.replaceAll("@transcript_3", document?.transcript[3]?.grade);
					let resources0 = transcript3.replaceAll("@resource_0", getObjectValue(document, "additionalData.resources[0].url", ""));
					let certShortUrl = resources0.replaceAll("@Certificate_Short_URL", document?.additionalDataMain?.shortURLs?.publicUrl);
					let certExpireAt = certShortUrl.replaceAll("@CertExpireDate_MMYY", document?.expireAt ? format(new Date(document?.expireAt), "MM/yy") : "");

					let certFinalData = certExpireAt.replaceAll("@IssuedMonthYear", format(new Date(document?.issuedOn), "MMMM yyyy"));

					for (let x = 0; x <= 15; x++) {
						certFinalData = certFinalData.replaceAll(`@Transcript${x}`, getObjectValue(document, `transcript[${x}].grade`, ""));
					}

					// @CONDITION_CHECK
					// 	@CONDITION_TYPE
					// 		@resources
					// 	@CONDITION_TYPE
					// 	@CONDITION_LENGTH
					// 		0
					// 	@CONDITION_LENGTH
					// 	@CONDITION_NOT_VIEW
					// 		TEXT
					// 	@CONDITION_NOT_VIEW
					// @CONDITION_CHECK

					const strData = (certFinalData.match(/@CONDITION_CHECK(.*?)@CONDITION_CHECK/g) || []).map((val) => {
						const conData = val.replace(/@CONDITION_CHECK/g, "");
						const type = (conData.match(/@CONDITION_TYPE(.*?)@CONDITION_TYPE/g) || []).map((len) => len.replace(/@CONDITION_TYPE/g, ""))[0];
						const length = (conData.match(/@CONDITION_LENGTH(.*?)@CONDITION_LENGTH/g) || []).map((len) => len.replace(/@CONDITION_LENGTH/g, ""))[0] || 0;
						const notViewVal = (conData.match(/@CONDITION_NOT_VIEW(.*?)@CONDITION_NOT_VIEW/g) || []).map((len) => len.replace(/@CONDITION_NOT_VIEW/g, ""))[0] || "";
						return { type, length: parseInt(length), notViewVal };
					});

					if (strData && strData.length) {
						certFinalData = certFinalData.replaceAll(/@CONDITION_CHECK(.*?)@CONDITION_CHECK/g, "@CHECK_MAIN_CONTENT");
						strData.forEach((item) => {
							const { type, length, notViewVal } = item;
							if (type === "@resources") {
								if (getObjectValue(document, "additionalData.resources", []).length !== length) {
									certFinalData = certFinalData.replace("@CHECK_MAIN_CONTENT", notViewVal);
								} else {
									certFinalData = certFinalData.replace("@CHECK_MAIN_CONTENT", "");
								}
							}
						});
					}

					// @CONDITION_VALUE_CHECK
					// 	@CONDITION_TYPE
					// 		@transcripts
					// 	@CONDITION_TYPE
					// 	@CONDITION_INDEX
					// 		0
					// 	@CONDITION_INDEX
					// 	@CONDITION_TO_CHECK_VIEW
					// 		TEXT
					// 	@CONDITION_TO_CHECK_VIEW
					// 	@CONDITION_TO_PRINT_VALUE
					// 		TEXT
					// 	@CONDITION_TO_PRINT_VALUE
					// @CONDITION_VALUE_CHECK

					const strTranscriptData = (certFinalData.match(/@CONDITION_VALUE_CHECK(.*?)@CONDITION_VALUE_CHECK/g) || []).map((val) => {
						const conData = val.replace(/@CONDITION_VALUE_CHECK/g, "");
						const type = (conData.match(/@CONDITION_TYPE(.*?)@CONDITION_TYPE/g) || []).map((len) => len.replace(/@CONDITION_TYPE/g, ""))[0];
						const index = (conData.match(/@CONDITION_INDEX(.*?)@CONDITION_INDEX/g) || []).map((len) => len.replace(/@CONDITION_INDEX/g, ""))[0] || 0;
						const toCheckVal = (conData.match(/@CONDITION_TO_CHECK_VIEW(.*?)@CONDITION_TO_CHECK_VIEW/g) || []).map((len) => len.replace(/@CONDITION_TO_CHECK_VIEW/g, ""))[0] || "";
						const toPrintVal = (conData.match(/@CONDITION_TO_PRINT_VALUE(.*?)@CONDITION_TO_PRINT_VALUE/g) || []).map((len) => len.replace(/@CONDITION_TO_PRINT_VALUE/g, ""))[0] || "";
						const toPrintValDisplay = (conData.match(/@CONDITION_TO_PRINT_VALUE_DISPLAY(.*?)@CONDITION_TO_PRINT_VALUE_DISPLAY/g) || []).map((len) => len.replace(/@CONDITION_TO_PRINT_VALUE_DISPLAY/g, ""))[0] || "";
						return { type, index: parseInt(index), toCheckVal, toPrintVal, toPrintValDisplay };
					});

					if (strTranscriptData && strTranscriptData.length) {
						certFinalData = certFinalData.replaceAll(/@CONDITION_VALUE_CHECK(.*?)@CONDITION_VALUE_CHECK/g, "@CHECK_VALUE_MAIN_CONTENT");
						strTranscriptData.forEach((item) => {
							const { type, index, toCheckVal, toPrintValDisplay = "" } = item;
							let { toPrintVal } = item;
							if (type === "@transcripts") {
								const transcriptValue = getObjectValue(document, `transcript[${index}].grade`, "");
								if (transcriptValue === toCheckVal) {
									if (toPrintVal.includes(`@KEY${index}_TRANSCRIPT`)) {
										toPrintVal = toPrintVal.replace(`@KEY${index}_TRANSCRIPT`, getObjectValue(document, `transcript[${index}].name`, ""));
									}
									certFinalData = certFinalData.replace("@CHECK_VALUE_MAIN_CONTENT", toPrintVal);
								} else {
									if (toPrintValDisplay == "true") {
										certFinalData = certFinalData.replace("@CHECK_VALUE_MAIN_CONTENT", toPrintVal || "");
									} else if (toPrintValDisplay == "showOnTranscriptValue") {
										if (transcriptValue) {
											if (toPrintVal.includes(`@KEY${index}_TRANSCRIPT`)) {
												toPrintVal = toPrintVal.replace(`@KEY${index}_TRANSCRIPT`, getObjectValue(document, `transcript[${index}].name`, ""));
											}
											certFinalData = certFinalData.replace("@CHECK_VALUE_MAIN_CONTENT", toPrintVal);
										} else {
											certFinalData = certFinalData.replace("@CHECK_VALUE_MAIN_CONTENT", "");
										}
									} else {
										certFinalData = certFinalData.replace("@CHECK_VALUE_MAIN_CONTENT", "");
									}
								}
							}
						});
					}

					// @FOR_LOOP
					// 	@FOR_LENGTH
					// 		10 // put 0 for looping only to the section with splitted ', ' in the value
					// 	@FOR_LENGTH
					// 	@FOR_SECTION
					// 		@resources
					// 	@FOR_SECTION
					// 	@FOR_MATCH_TEXT_KEY
					// 		Industry Endorsements
					// 	@FOR_MATCH_TEXT_KEY
					// 	@FOR_CONTENT
					// 	@FOR_DATA_CONTENT
					// 	@FOR_CONTENT
					// @FOR_LOOP

					const dataStr = (certFinalData.match(/@FOR_LOOP(.*?)@FOR_LOOP/g) || []).map((val) => {
						const loopData = val.replace(/@FOR_LOOP/g, "");
						const section = (loopData.match(/@FOR_SECTION(.*?)@FOR_SECTION/g) || []).map((len) => len.replace(/@FOR_SECTION/g, ""))[0];
						const condition = (loopData.match(/@FOR_CONDITION(.*?)@FOR_CONDITION/g) || []).map((len) => len.replace(/@FOR_CONDITION/g, ""))[0];
						const content = (loopData.match(/@FOR_CONTENT(.*?)@FOR_CONTENT/g) || []).map((len) => len.replace(/@FOR_CONTENT/g, ""))[0];
						const length = (loopData.match(/@FOR_LENGTH(.*?)@FOR_LENGTH/g) || []).map((len) => len.replace(/@FOR_LENGTH/g, ""))[0] || 0;
						const matchTextKey = (loopData.match(/@FOR_MATCH_TEXT_KEY(.*?)@FOR_MATCH_TEXT_KEY/g) || []).map((len) => len.replace(/@FOR_MATCH_TEXT_KEY/g, ""))[0] || "";
						return { section, content, condition, length, matchTextKey };
					});

					if (dataStr.length) {
						const dataMap = {
							"@transcript0": "transcript[0].grade",
							"@transcript1": "transcript[1].grade",
							"@resources": "additionalData.resources",
						};
						certFinalData = certFinalData.replaceAll(/@FOR_LOOP(.*?)@FOR_LOOP/g, "@FOR_MAIN_CONTENT");
						dataStr.forEach((item) => {
							let mappedData = "";
							if (item.length > 0) {
								const { [item.section]: itemSection } = dataMap;
								const baseProp = getObjectValue(document, itemSection, []);
								for (let x = 0; x < item.length; x++) {
									if (item.section === "@resources") {
										if (getObjectValue(baseProp, `${x}.id`, "").match(item.matchTextKey)) {
											mappedData += item.content.replace("@FOR_DATA_CONTENT", getObjectValue(baseProp, `${x}.url`));
											if (item.condition === "matchOne") {
												break;
											}
										}
									}
								}
							} else {
								const { [item.section]: itemSection } = dataMap;
								const data = getObjectValue(document, itemSection, "");
								if (data) {
									const splittedItems = data.split(", ");
									for (let x = 0; x < splittedItems.length; x++) {
										const { [x]: value } = splittedItems;
										mappedData += item.content.replace("@FOR_DATA_CONTENT", value);
									}
								}
							}
							certFinalData = certFinalData.replace("@FOR_MAIN_CONTENT", mappedData);
						});
					}

					setCredData(null);
					setTimeout(() => {
						try {
							const parsedCertFinalData = JSON.parse(certFinalData);

							let updatedEntityMap = {};
							const parentElement = isFullScreen ? window.document.getElementById("zoomed-certificate") : window.document.getElementById("zoomed-out-certificate");
							const clientWidth = parentElement.clientWidth - 10;
							const parsedContainerStyle = JSON.parse(parsedConfig.style);
							if (parentElement) {
								Object.keys(parsedCertFinalData?.entityMap).forEach((value) => {
									const { fontSize, paddingBottom, paddingLeft, paddingTop, paddingRight, marginTop, marginBottom, marginLeft, marginRight, top, right, left, bottom, height, width, maxHeight, maxWidth } =
										parsedCertFinalData?.entityMap[value].data.styleString;
									let updatedStyle = {};
									if (paddingTop?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											paddingTop: (clientWidth * Number(paddingTop?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (paddingLeft?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											paddingLeft: (clientWidth * Number(paddingLeft?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (paddingRight?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											paddingRight: (clientWidth * Number(paddingRight?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (paddingBottom?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											paddingBottom: (clientWidth * Number(paddingBottom?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (fontSize?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											fontSize: (clientWidth * Number(fontSize?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (marginTop?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											marginTop: (clientWidth * Number(marginTop?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (marginBottom?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											marginBottom: (clientWidth * Number(marginBottom?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (marginLeft?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											marginLeft: (clientWidth * Number(marginLeft?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (marginRight?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											marginRight: (clientWidth * Number(marginRight?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (top?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											top: (clientWidth * Number(top?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (right?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											right: (clientWidth * Number(right?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (left?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											left: (clientWidth * Number(left?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (bottom?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											bottom: (clientWidth * Number(bottom?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (height?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											height: (clientWidth * Number(height?.replace("vw", ""))) / 100 + "px",
										};
									}
									if (width?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											width: (clientWidth * Number(width?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (maxHeight?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											maxHeight: (clientWidth * Number(maxHeight?.replace("vw", ""))) / 100 + "px",
										};
									}

									if (maxWidth?.includes("vw")) {
										updatedStyle = {
											...updatedStyle,
											maxWidth: (clientWidth * Number(maxWidth?.replace("vw", ""))) / 100 + "px",
										};
									}

									let val = parsedCertFinalData?.entityMap[value].data?.val;
									if (parsedCertFinalData?.entityMap[value].data?.val) {
										val = parsedCertFinalData?.entityMap[value].data?.val.replace(/:\s*([\d.]+)vw/gm, (m, value) => `: ${parseInt((clientWidth * Number(value)) / 100)}px`);
									}
									updatedEntityMap[value] = {
										...parsedCertFinalData?.entityMap[value],
										data: {
											...parsedCertFinalData?.entityMap[value].data,
											val: val,
											styleString: {
												...parsedCertFinalData?.entityMap[value].data.styleString,
												...updatedStyle,
											},
										},
									};
								});
								parsedCertFinalData.entityMap = updatedEntityMap;
								setCredData(JSON.stringify(parsedCertFinalData));
								scaleFullScreen.current = Number(parsedContainerStyle?.paddingTop?.replace("%", "")) > 70;
								setStyle(
									JSON.stringify({
										...parsedContainerStyle,
										marginTop: isFullScreen ? "auto" : 0,
										pointerEvents: "none",
										width: "90%",
										transform: "scale(1)",
										marginBottom: 0,
									})
								);
							} else {
								setCredData(certFinalData);
							}
						} catch (err) {
							setShowSimple(true);
							if (!snackbarInitiated.current) {
								snackbarInitiated.current = true;
								enqueueSnackbar("WARNING: Due to some error we are not able display your credential. please contact support.", { variant: "warning" });
							}
							console.error(err);
						}
					}, 0);
					setStyle(parsedConfig.style);
					setPrintOrientation(parsedConfig?.printOrientation);
				} catch (err) {
					setShowSimple(true);
					if (!snackbarInitiated.current) {
						snackbarInitiated.current = true;
						enqueueSnackbar("WARNING: Due to some error we are not able display your credential. please contact support.", { variant: "warning" });
					}
					console.error(err);
				}
			} else {
				setCredData(
					JSON.stringify({
						blocks: [
							{
								key: "b8r3o",
								text: "",
								type: "unstyled",
								depth: 0,
								inlineStyleRanges: [],
								entityRanges: [],
								data: {},
							},
							{
								key: "58gar",
								text: " ",
								type: "atomic",
								depth: 0,
								inlineStyleRanges: [],
								entityRanges: [{ offset: 0, length: 1, key: 0 }],
								data: {},
							},
							{
								key: "a6jgi",
								text: "",
								type: "unstyled",
								depth: 0,
								inlineStyleRanges: [],
								entityRanges: [],
								data: {},
							},
						],
						entityMap: {
							0: {
								type: "CRED_NAME",
								mutability: "MUTABLE",
								data: {
									val: "Credential Needs Custom Styles",
									styleString: { fontSize: "10vw", color: "red" },
								},
							},
						},
					})
				);
			}
		} catch (error) {
			setShowSimple(true);
			if (!snackbarInitiated.current) {
				snackbarInitiated.current = true;
				enqueueSnackbar("WARNING: Due to some error we are not able display your credential. please contact support.", { variant: "warning" });
			}
			console.error(error);
		}
	}, [config.data, document?.id]);

	return (
		<div
			className={isFullScreen ? "DraftEditor-full-screen" : ""}
			style={{
				position: "relative",
				transform: scaleFullScreen.current && isFullScreen ? "scale(0.7)" : "scale(1)",
			}}>
			<div style={{
				flexGrow: 1,
				overflow: "hidden",
				border: "1px solid transparent",
				fontFamily: "TimesNewRoman, 'Times New Roman', Times, Baskerville, Georgia, serif",
			}} ref={ref}>
				<div className="wrap-body">{credData && <DraftRenderer className="OnePageImage" data={credData} styleString={style} printOrientation={printOrientation} />}</div>
			</div>
			{/* {isFullScreen ? (
				<span style={{ position: "absolute", zIndex: 10, right: "4.5vw", top: "2vw" }}>
					<Button
						buttonType="icon"
						color={"white"}
						icon="cancel-circle"
						iconStyle={{ weight: "fill", color: "#C0C0C0" }}
						noBorder={true}
						borderRadius={"50%"}
						buttonStyle={{ padding: 0, backgroundColor: "transparent" }}
						iconSize="2rem"
						onClick={(e) => {
							e?.stopPropagation();
							onClose();
						}}
					/>
				</span>
			) : (
				<span style={{ position: "absolute", zIndex: 10, right: 10, bottom: 10 }}>
					<Button
						buttonType="icon"
						color={"white"}
						icon="arrowsOut"
						iconStyle={{ weight: "fill", color: "#C0C0C0" }}
						noBorder={true}
						borderRadius={"50%"}
						buttonStyle={{ padding: 0, backgroundColor: "transparent" }}
						iconSize="1.5rem"
						onClick={(e) => {
							e?.stopPropagation();
							onZoom();
						}}
					/>
				</span>
			)} */}
		</div>
	);
});

export default DesignContainer;
